var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "buy-money-box" }, [
    _c("div", {
      ref: "buyMoney",
      staticClass: "buyMoney",
      attrs: { id: "buyMoney" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }